import React, { ReactNode, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { EProductType } from '@quesmed/types-rn/models';

import { AppProductType } from 'types';
import { useSampleData } from './hooks';
import { randomFromRange } from 'utils';

interface SampleQuestionsProps {
  productType: AppProductType;
  children: ReactNode;
}

const SampleQuestionsController = ({
  productType,
  children,
}: SampleQuestionsProps) => {
  const { marksheetId: marksheetIdFromParams } = useParams<{
    marksheetId: string;
  }>();
  const isQbank = productType === EProductType.QBANK;

  const { marksheets } = useSampleData(
    productType,
    Boolean(marksheetIdFromParams)
  );
  const navigate = useNavigate();

  const marksheetId = useMemo(() => {
    if (marksheetIdFromParams) {
      return marksheetIdFromParams;
    }

    const index = marksheets
      ? randomFromRange(0, marksheets.length - 1)
      : undefined;

    if (isQbank) {
      return (
        marksheets?.find(
          marksheet => marksheet.entitlement.id === EProductType.CLINICAL
        )?.id || undefined
      );
    }

    const marksheetData =
      typeof index === 'number' ? marksheets?.[index] : undefined;

    return marksheetData ? Number(marksheetData.id) : undefined;
  }, [marksheetIdFromParams, marksheets, isQbank]);

  useEffect(() => {
    if (marksheetId) {
      navigate(`/sample/${productType}/questions/solo/quiz/${marksheetId}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productType, marksheetId]);

  return <>{children}</>;
};

export default SampleQuestionsController;
